var map = {
	"./fr/failure/fr_failure_1.png": "72be",
	"./fr/failure/fr_failure_2.png": "4b6b",
	"./fr/failure/fr_failure_3.png": "2074",
	"./fr/failure/fr_failure_4.png": "c3ce",
	"./fr/failure/fr_failure_5.png": "f870",
	"./fr/failure/fr_failure_6.png": "2ae2",
	"./fr/failure/fr_failure_7.png": "9083",
	"./fr/failure/fr_failure_8.png": "6e7f",
	"./fr/success/fr_success_1.png": "3c8e",
	"./fr/success/fr_success_2.png": "a7d6",
	"./fr/success/fr_success_3.png": "1627",
	"./fr/success/fr_success_4.png": "df3c",
	"./fr/success/fr_success_5.png": "b7a5",
	"./fr/success/fr_success_6.png": "7580",
	"./fr/success/fr_success_7.png": "8760",
	"./lv/failure/lv_failure_1.png": "d16f",
	"./lv/failure/lv_failure_2.png": "955f",
	"./lv/failure/lv_failure_3.png": "8696",
	"./lv/failure/lv_failure_4.png": "914d",
	"./lv/failure/lv_failure_5.png": "a323",
	"./lv/failure/lv_failure_6.png": "6647",
	"./lv/failure/lv_failure_7.png": "72de",
	"./lv/failure/lv_failure_8.png": "b5c9",
	"./lv/success/lv_seccess_7.png": "ff66",
	"./lv/success/lv_success_1.png": "c11e",
	"./lv/success/lv_success_2.png": "6341",
	"./lv/success/lv_success_3.png": "1f1d",
	"./lv/success/lv_success_4.png": "48f0",
	"./lv/success/lv_success_5.png": "8ffe",
	"./lv/success/lv_success_6.png": "9d4e",
	"./ru/failure/ru_failure_1.png": "f268",
	"./ru/failure/ru_failure_2.png": "ddec",
	"./ru/failure/ru_failure_3.png": "956e",
	"./ru/failure/ru_failure_4.png": "db31",
	"./ru/failure/ru_failure_5.png": "3340",
	"./ru/failure/ru_failure_6.png": "ae34",
	"./ru/failure/ru_failure_7.png": "c08f",
	"./ru/failure/ru_failure_8.png": "ca62",
	"./ru/success/ru_success_1.png": "9ffd",
	"./ru/success/ru_success_2.png": "0d6b",
	"./ru/success/ru_success_3.png": "c876",
	"./ru/success/ru_success_4.png": "d043",
	"./ru/success/ru_success_5.png": "cd31",
	"./ru/success/ru_success_6.png": "3d53",
	"./ru/success/ru_success_7.png": "d150",
	"./uk/failure/uk_failure_1.png": "1b0d",
	"./uk/failure/uk_failure_2.png": "e020",
	"./uk/failure/uk_failure_3.png": "a6db",
	"./uk/failure/uk_failure_4.png": "ab62",
	"./uk/failure/uk_failure_5.png": "18ad",
	"./uk/failure/uk_failure_6.png": "e5dba",
	"./uk/failure/uk_failure_7.png": "a030",
	"./uk/failure/uk_failure_8.png": "2059",
	"./uk/success/uk_success_1.png": "3bb8",
	"./uk/success/uk_success_2.png": "9716",
	"./uk/success/uk_success_3.png": "0c0c",
	"./uk/success/uk_success_4.png": "6b0b",
	"./uk/success/uk_success_5.png": "a63e",
	"./uk/success/uk_success_6.png": "3b1b",
	"./uk/success/uk_success_7.png": "7ea8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35b7";